<div
  class="layout-wrapper flex min-h-screen w-full bg-surface-ground"
  [style.--sidebar-current-width.px]="sidebarWidth()"
  [style.--app-shell-content-height]="shellContentHeight"
  [attr.data-route-scroll-mode]="activeRouteScrollMode()"
>
  <app-sidebar />

  @if (isMobileViewport() && !isMobileOverlayOpen()) {
    <button
      type="button"
      class="layout-mobile-sidebar-toggle"
      aria-label="Otwórz nawigację boczną"
      (click)="openMobileSidebar()"
    >
      <i class="pi pi-bars" aria-hidden="true"></i>
    </button>
  }

  <main class="layout-main flex min-h-screen flex-col transition-[margin-left] duration-300 ease-in-out">
    <div
      class="layout-content h-full w-full max-w-full flex-1 bg-surface-ground"
      [attr.data-route-scroll-mode]="activeRouteScrollMode()"
    >
      <router-outlet />
    </div>
  </main>

  <div class="layout-toast-host" aria-live="polite">
    <p-toast
      class="layout-toast"
      [key]="globalToastKey"
      position="bottom-right"
      [autoZIndex]="false"
      [baseZIndex]="3000"
    />
  </div>

  <app-drawer />
</div>
